<!-- 我的证书 -->
<template>
  <div class="certificate">
    <div class="wrap">
      <el-form :inline="true">
        <el-form-item label="证书类型">
          <el-select v-model="queryParams.subjectName" clearable>
            <el-option
              v-for="item in subjects"
              :key="item.id"
              :label="item.subjectName"
              :value="item.subjectName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" @click="onSearch"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <el-table :data="list" empty-text="暂无证书">
        <el-table-column label="姓名" prop="userName"></el-table-column>
        <el-table-column label="身份证" prop="idNo"></el-table-column>
        <el-table-column label="证书类型" prop="subjectName"></el-table-column>
        <el-table-column
          label="专业名称(岗位、工种)"
          prop="workTypeName"
        ></el-table-column>
        <el-table-column
          label="证书编号"
          prop="certNum"
          align="center"
        ></el-table-column>
        <el-table-column label="电子证书">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              icon="el-icon-s-check"
              @click="downloadMyCert(row)"
              >下载证书</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ip } from "../../util/config";
export default {
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 50,
        subjectName: "",
        workTypeName: "",
        status: "3",
      },
      subjects: [],
      list: [],
    };
  },
  created() {
    this.$api.getCertificateTypes().then((res) => {
      this.subjects = res.data;
    });
    this.getList();
  },
  methods: {
    currentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    async getList() {
      let res = await this.$api.getMyApplyList(this.queryParams);
      this.list = res.data.list;
      this.total = res.data.total;
    },
    onSearch() {
      this.queryParams.pageIndex = 1;
      this.getList();
    },
    // 下载我的证书
    downloadMyCert(row) {
      // 下载证书api
      axios
        .get(ip + "jianxie/certificate-apply-form/front/getcertApplyPdf", {
          params: { certNum: row.certNum },
          responseType: "blob",
          headers: {
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          let url = window.URL.createObjectURL(res.data);
          let a = document.createElement("a");
          a.href = url;
          a.download = row.certNum + ".pdf";
          a.click();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
}
</style>
